import { AppRouteProps } from "@bsm/component";
import React from "react";

const InvoiceCreateManuallyContainer = React.lazy(() => import("./container/InvoiceCreateManuallyContainer"))

export const InvoiceCreateManuallyRoute = [
    {
        path: "create/manually",
        element: <InvoiceCreateManuallyContainer />
    }
] as Array<AppRouteProps>